"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DataItem_1 = require("../../common/base/DataItem");
var Field_1 = require("../../../constants/Field");
var DataType_1 = require("../../common/base/DataType");
var Alarm = /** @class */ (function () {
    function Alarm() {
    }
    Alarm.fromJson = function (alarmName, path, json) {
        var alarm = new Alarm();
        alarm.alarmName = alarmName;
        alarm.path = path + "/" + alarmName;
        alarm.alarmType = DataItem_1.DataItem.fromJson(Field_1.FIELD.ALARMTYPE, json[Field_1.FIELD.ALARMTYPE]);
        return alarm;
    };
    Alarm.prototype.toJson = function (includeOnlyVariableData) {
        var json = Object.create(null);
        var alarmType = this.alarmType.toJson(includeOnlyVariableData);
        json[this.alarmName] = alarmType;
        return json;
    };
    Alarm.prototype.getAlarmConditionVariable = function () {
        var conditionVariable = Object.create(null);
        conditionVariable[Field_1.FIELD.DATATYPE] = DataType_1.DataType.string;
        conditionVariable[Field_1.FIELD.OBJECTLINK] = this.path;
        var json = Object.create(null);
        json[this.alarmName + "Alarm"] = conditionVariable;
        return json;
    };
    return Alarm;
}());
exports.Alarm = Alarm;
//# sourceMappingURL=Alarm.js.map